<template>
  <div>
    <ProposalData></ProposalData>
  </div>
</template>

<script>

import ProposalData from '../components/ProposalData.vue';

export default {
  components: {
    ProposalData,
  },
};
</script>